
import "./spinner.css";

import React from 'react';

export default function Spinner() {
  return <div class="loader">Loading...</div>;
}
